/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Button,
  Input,
  InputGroup,
  Loader,
  IconButton,
  Form,
  SelectPicker,
} from 'rsuite';
import { MdAdd, MdSearch, MdEdit, MdDelete } from 'react-icons/md';
import { toast } from 'react-toastify';

import {
  Container,
  Header,
  FiltersRow,
  QuestionCard,
  EmptyState,
} from './styles';
import QuestionEditor from './components/QuestionEditor';
import ConfirmDialog from './components/ConfirmDialog';
import {
  getQuestoes,
  createQuestao,
  updateQuestao,
  deleteQuestao,
} from '../../services/treinamentos';
import api from '../../services/api';

const BancoQuestoes = () => {
  const [questoes, setQuestoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [busca, setBusca] = useState('');
  const [categoriasQuestoes, setCategoriasQuestoes] = useState([]);
  const [id_categoria, setId_categoria] = useState();
  
  // Modal de edição/criação
  const [editorOpen, setEditorOpen] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [savingQuestion, setSavingQuestion] = useState(false);

  // Modal de exclusão
  const [deleteModal, setDeleteModal] = useState({ open: false, id: null, enunciado: '' });
  const [deleting, setDeleting] = useState(false);

  const loadQuestoes = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getQuestoes(pagina, busca, id_categoria);
      setQuestoes(data.questoes || []);
      setTotal(data.total || 0);
      setTotalPaginas(data.paginas || 1);
    } catch (error) {
      toast.error('Erro ao carregar questões');
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [pagina, busca, id_categoria]);

  const buscarCategoriasQuestoes = useCallback(async () => {
        try {
          const resposta = await api.get('categorias-questoes');
          setCategoriasQuestoes(resposta.data.categorias);
        } catch (error) {
          console.error('Erro ao buscar categorias de questões:', error);
        }
      }, []);

  useEffect(() => {
    loadQuestoes();
    buscarCategoriasQuestoes();
  }, [loadQuestoes]);

  const handleSearch = useCallback((value) => {
    setBusca(value);
    setPagina(1);
  }, []);

  const handleCreate = useCallback(() => {
    setEditingQuestion(null);
    setEditorOpen(true);
  }, []);

  const handleEdit = useCallback((questao) => {
    setEditingQuestion(questao);
    setEditorOpen(true);
  }, []);

  const handleSaveQuestion = useCallback(async (data) => {
    setSavingQuestion(true);
    if (data.id_categoria === null || data.id_categoria === undefined) {
      toast.error('Por favor, selecione uma categoria para a questão.');
      setSavingQuestion(false);
      return;
    }
    try {
      if (editingQuestion) {
        await updateQuestao(editingQuestion.id, {
          enunciado: data.enunciado,
          feedback_acerto: data.feedback_acerto,
          feedback_erro: data.feedback_erro,
          id_categoria: data.id_categoria,
          alternativas: data.alternativas.map((alt, index) => ({
            id: alt.id,
            texto: alt.texto,
            correta: alt.correta,
            ordem: index + 1,
          })),
        });
        toast.success('Questão atualizada com sucesso!');
      } else {
        await createQuestao(data);
        toast.success('Questão criada com sucesso!');
      }
      setEditorOpen(false);
      setEditingQuestion(null);
      loadQuestoes();
    } catch (error) {
      toast.error(error.message || 'Erro ao salvar questão');
    } finally {
      setSavingQuestion(false);
    }
  }, [editingQuestion, loadQuestoes]);

  const handleDelete = useCallback(async () => {
    if (!deleteModal.id) return;

    setDeleting(true);
    try {
      await deleteQuestao(deleteModal.id);
      toast.success('Questão excluída com sucesso!');
      setDeleteModal({ open: false, id: null, enunciado: '' });
      loadQuestoes();
    } catch (error) {
      toast.error(error.message || 'Erro ao excluir questão');
    } finally {
      setDeleting(false);
    }
  }, [deleteModal.id, loadQuestoes]);

  return (
    <Container>
      <Header>
        <h1>Banco de Questões</h1>
        <Button appearance="primary" onClick={handleCreate}>
          <MdAdd style={{ marginRight: 8 }} />
          Nova Questão
        </Button>
      </Header>

      <FiltersRow>
        <InputGroup style={{ width: 300 }}>
          <InputGroup.Addon>
            <MdSearch />
          </InputGroup.Addon>
          <Input
            placeholder="Buscar por enunciado..."
            value={busca}
            onChange={handleSearch}
          />
        </InputGroup>
        <Form fluid>
          <Form.Group>
            <SelectPicker
              data={categoriasQuestoes.map((cat) => ({
                label: cat.nome,
                value: cat.id,
              }))}
              value={id_categoria}
              onChange={(value) => setId_categoria(value)}
              placeholder="Selecione a categoria"
            />
          </Form.Group>
        </Form>
      </FiltersRow>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <Loader size="lg" content="Carregando questões..." />
        </div>
      ) : questoes.length === 0 ? (
        <EmptyState>
          <MdSearch style={{ fontSize: 48 }} />
          <h3>Nenhuma questão encontrada</h3>
          <p>Crie questões para usar nos treinamentos</p>
          <Button appearance="primary" onClick={handleCreate}>
            <MdAdd style={{ marginRight: 8 }} />
            Criar Questão
          </Button>
        </EmptyState>
      ) : (
        <>
          <p style={{ marginBottom: 16, color: '#888' }}>
            {total} questão(ões) encontrada(s)
          </p>

          {questoes.map((questao) => (
            <QuestionCard key={questao.id}>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>

              <div className="question-header">{questao.enunciado}</div>
              <div style={{color: '#bbb'}}>Categoria: {questao.categorias_questoes &&questao.categorias_questoes.nome ? questao.categorias_questoes.nome : 'Genérico'}</div>
              </div>
              
              {questao.alternativas && (
                <div className="alternatives">
                  {questao.alternativas.map((alt) => (
                    <div
                      key={alt.id}
                      className={`alternative ${alt.correta ? 'correct' : ''}`}
                    >
                      {alt.correta ? '✓' : '○'} {alt.texto}
                    </div>
                  ))}
                </div>
              )}

              <div className="question-meta">
                <span>
                  {/* Aqui poderia mostrar em quantos módulos é usada */}
                  {questao.alternativas?.length || 0} alternativas
                </span>
                <div style={{ display: 'flex', gap: 8 }}>
                  <IconButton
                    icon={<MdEdit />}
                    appearance="subtle"
                    size="sm"
                    onClick={() => handleEdit(questao)}
                  />
                  <IconButton
                    icon={<MdDelete />}
                    appearance="subtle"
                    color="red"
                    size="sm"
                    onClick={() =>
                      setDeleteModal({
                        open: true,
                        id: questao.id,
                        enunciado: questao.enunciado,
                      })
                    }
                  />
                </div>
              </div>
            </QuestionCard>
          ))}

          {/* Paginação simples */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20 }}>
            <Button
              disabled={pagina <= 1}
              onClick={() => setPagina((p) => p - 1)}
            >
              Anterior
            </Button>
            <span style={{ padding: '8px 16px' }}>
              Página {pagina} de {totalPaginas}
            </span>
            <Button
              disabled={pagina >= totalPaginas}
              onClick={() => setPagina((p) => p + 1)}
            >
              Próxima
            </Button>
          </div>
        </>
      )}

      {/* Modal de edição/criação */}
      <QuestionEditor
        open={editorOpen}
        onClose={() => {
          setEditorOpen(false);
          setEditingQuestion(null);
        }}
        onSave={handleSaveQuestion}
        initialData={editingQuestion}
        loading={savingQuestion}
      />

      {/* Modal de confirmação de exclusão */}
      <ConfirmDialog
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, id: null, enunciado: '' })}
        onConfirm={handleDelete}
        title="Excluir Questão"
        message={`Tem certeza que deseja excluir esta questão? Esta ação não pode ser desfeita e pode afetar módulos que usam esta questão.`}
        confirmText="Excluir"
        loading={deleting}
      />
    </Container>
  );
}

export default BancoQuestoes;
